import { rows, DataGrid } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import ImportProfiles from "../controllers/ImportProfiles/ImportProfiles";
import { getConfigVariable } from "../config/config";

const queries = (args = {}) => {
    const resource = "import_profiles";
    const queryArgs = {
        projectId: { type: "String!", value: args.projectId },
        filter: args.filter
            ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
            : undefined,
        sort: args.sort ? { type: "[SortInput!]", value: parseFilter(args.sort) } : undefined,
        page: parseInt(args.page, 10) || 0,
        pageSize: parseInt(args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE")),
    };

    const queryBody = `__typename, hasMore, total, items { ...import_profiles }, filters { prop, name, type, list, disableOperators, mandatory }, rawDataEdit`;

    return [
        {
            resource,
            args: { ...queryArgs },
            body: queryBody,
            downloadable: false,
            isDatagridReq: true,
        },
    ];
};

const importProfilesMapping = (path, navigation, exact, title) => ({
    path,
    navigation,
    component: ImportProfiles,
    exact,
    queries,
    title: [title],
    components: [
        {
            component: DataGrid,
            props: {
                id: "results",
                card: rows.CellCard,
                items: "query(0).list",
                total: "query(0).total",
                rawDataEdit: "query(0).rawDataEdit",
                header: "query(0).header",
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                sort: "param(sort)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                wrapper: "wrapper",
                showCheckbox: false,
                onRowEdit: true,
                cellHighlight: false,
                hideDeleteSeriesButton: true,
                onRowClickCustom: () => {},
            },
        },
    ],
});

export default importProfilesMapping;
